import React from 'react';
import Navbar from '../components/navBar';
import Footer from '../components/footer';
import BottomBar from '../components/BottomBar';
const faqs = [
  {
    question: 'What kind of products do you create at G.Collection786?',
    answer: 'We are entirely dedicated to handmade artistry! Our curated collection features beautiful, one-of-a-kind items crafted with love, including customized hijab pins & arm flowers, handmade bookmarks, aesthetic diaries, custom appliqué patti, elegant brooches, and cozy crochet items.'
  },
  {
    question: 'How can I place an order for a customized item?',
    answer: 'Ordering is simple! Browse our collection online, select the item you love, and look for the customization options before adding it to your cart. For highly detailed or specific visions—like custom appliqué patti—feel free to reach out to us directly so we can bring your ideas to life.'
  },
  {
    question: 'Are your items ready-made, or are they made to order?',
    answer: 'Because we believe the most meaningful things in life are made by hand, many of our bespoke and customized pieces are made to order just for you. This ensures that every single item we create is truly unique, high-quality, and infused with personal care.'
  },
  {
    question: 'Can I order items as gifts or request bulk quantities?',
    answer: 'Absolutely! Our handmade creations make the perfect, thoughtful gifts for your loved ones. Whether you need a single custom piece or bulk orders for special occasions and events, just reach out to us—we would love to craft something memorable for you.'
  }
];


const FAQPage = () => {
  return (
    <>
           <div className='sticky'>
            <Navbar/>
        </div>
    <div className="faq-container">
      <h1 className="faq-title">Frequently Asked Questions</h1>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <details key={index} className="faq-item">
            <summary className="faq-question">
              {faq.question}
            </summary>
            <p className="faq-answer">{faq.answer}</p>
          </details>
        ))}
      </div>
    </div>
    <BottomBar/>
             <Footer/>
             </>
  );
};

export default FAQPage;
